<!--
 * @Descripttion: 
 * @version: 
 * @Author: lzs
 * @Date: 2022-05-27 16:47:57
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-06-01 15:49:16
-->
<template>
  <div class="electric-board">
    <div v-if="isFullScreen" class="electric-board-head">
      <div>
        <span>用电看板</span>
      </div>
      <div>
        <!-- 天气 -->
        <div class="weather-box">
          <div class="weather-content" v-if="weather !== null">
            <img :src="'/resources/weather/' + weather.code + '@1x.png'" />
            <label>{{ weather.text }}</label>
            <label>{{ weather.temperature }}°C</label>
          </div>
        </div>
        <p class="time">{{ date }} {{ week }} {{ time }}</p>
      </div>
    </div>
    <div class="electric-board-container">
      <div class="left-box">
        <card title="电能耗统计">
          <drawer slot="content"></drawer>
        </card>
        <card title="分项用电概况" :showDateGroup="true">
          <div slot="content">
            <drawer title="生产用电概况"></drawer>
            <drawer title="辅助生产用电概况"></drawer>
            <drawer title="照明用电概况"></drawer>
            <drawer title="其他用电概况"></drawer>
          </div>
        </card>
      </div>
      <div class="right-box">
        <div class="right-session-1">
          <div class="left-item">
            <card title="当日分项用电占比" height="457px">
              <template #content>
                <div class="pie-date">
                  {{ $moment(new Date()).format('YYYY年MM月DD日'), }}
                </div>
                <chart ref="pie-chart"></chart>
              </template>
            </card>
          </div>
          <div class="right-item">
            <div class="right-item-1">
              <card title="负荷曲线" height="201px">
                <template #content>
                  <div ref="div-box" class="content-box">
                    <chart ref="line-chart-1"></chart>
                    <div class="right-info-box">
                      <div class="right-info">
                        <p class="info-title">昨日最大负荷</p>
                        <p class="info-value">360.5kW</p>
                        <p class="info-time">
                          <span>发生时间</span>
                          <span>8:40</span>
                        </p>
                      </div>
                      <div class="right-info">
                        <p class="info-title">今日最大负荷</p>
                        <p class="info-value">360.5kW</p>
                        <p class="info-time">
                          <span>发生时间</span>
                          <span>8:40</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </card>
            </div>
            <div class="right-item-2">
              <card title="电量同比分析" height="201px">
                <div class="content-box" slot="content">
                  <chart ref="line-chart-2"></chart>
                  <div class="right-info-box">
                    <div class="right-info">
                      <p class="info-title">昨日总电量</p>
                      <p class="info-value">360.5kW</p>
                    </div>
                    <div class="right-info">
                      <p class="info-title">今日总电量</p>
                      <p class="info-value">360.5kW</p>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <div class="right-session-2">
          <card title="年度用电趋势" height="370px">
            <template slot="content">
              <chart ref="line-chart-3"></chart>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./components/card.vue";
import Drawer from "./components/drawer.vue";
import Chart from "./components/chart.vue";

import { weather, weatherUpdateInterval } from "../../utils/weather";
import DateTool from "@/utils/dateTool.js";

export default {
  components: { Card, Drawer, Chart },
  data() {
    return {
      weather,
      weatherUpdateInterval,
      hourAxisArr: [],
      monthAxisArr: [],
      isFullScreen: false,
      containerWidth: "100%",
    };
  },
  mounted() {
    this.getWeather();
    this.getLangDate();
    window.addEventListener("resize", this.setListener);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setListener);
  },
  activated() {
    this.getPieChartData();
    this.getLoadCurveData();
    this.getPowerAnalysis();
    this.getElectricityTrend();
  },
  methods: {
    // 设置监听
    setListener() {
      if (window.innerHeight === screen.availHeight) {
        this.isFullScreen = true;
      } else {
        this.isFullScreen = false;
      }
      this.$nextTick(() => {
        this.$refs["line-chart-1"].resizeChart();
        this.$refs["line-chart-2"].resizeChart();
        this.$refs["line-chart-3"].resizeChart();
        this.getLoadCurveData();
        this.getPowerAnalysis();
        this.getElectricityTrend();
      });
    },
    // 获取天气
    getWeather() {
      weather.getWeather().then((res) => {
        if (res) {
          this.weather = res["results"][0].now;
          setTimeout(() => {
            this.getWeather();
          }, weatherUpdateInterval);
        }
      });
    },
    // 获取日期
    getLangDate() {
      const dateObj = new Date(); //表示当前系统时间的Date对象
      this.time = DateTool.format(dateObj, "hh:mm");
      this.date = DateTool.format(dateObj, "MM月dd日");
      const weeks = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const week = weeks[dateObj.getDay()]; //根据星期值，从数组中获取对应的星期字符串
      this.week = week;
      setTimeout(this.getLangDate, 1000);
    },
    getPieChartData() {
      const data = [
        { value: 1048, name: "生产用电" },
        { value: 735, name: "辅助生产用电" },
        { value: 580, name: "其他照明" },
        { value: 484, name: "其他用电" },
      ];
      this.$nextTick(() => {
        let option = {
          title: {
            text: "2,584,873.33",
            subtext: "kWh",
            left: "center",
            top: "middle",
            textStyle: {
              color: "#ffffff",
              fontSize: 24,
            },
            subtextStyle: {
              color: "#ffffff50",
              fontSize: 14,
            },
          },
          tooltip: {
            show: false,
          },
          color: ["#0098ff", "#1bd870", "#ffcc33", "#ff6600"],
          legend: {
            bottom: 10,
            left: "center",
            textStyle: {
              color: "#FFF",
            },
          },
          series: [
            {
              type: "pie",
              radius: ["45%", "60%"],
              label: {
                formatter: "{b}\n{c}kWh\n{d}%",
              },
              data,
            },
          ],
        };
        this.$refs["pie-chart"].$emit("setChart", option);
      });
    },
    getLoadCurveData() {
      this.$nextTick(() => {
        const option = {
          color: ["#0080FF", "#FFCC33"],

          xAxis: {
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },

          series: [
            {
              name: "今日用电",
              type: "line",
              stack: "Total",
              smooth: true,
              data: [120, 132, 101, 134, 90, 230, 210],
            },
            {
              name: "昨日用电",
              type: "line",
              stack: "Total",
              smooth: true,
              data: [220, 182, 191, 234, 290, 330, 310],
            },
          ],
        };
        console.log(this.$refs["div-box"].offsetWidth);
        this.$refs["line-chart-1"].$emit("setChart", option, true);
      });
    },
    getPowerAnalysis() {
      this.$nextTick(() => {
        const option = {
          color: ["#0080FF", "#FFCC33"],

          xAxis: {
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },

          series: [
            {
              name: "今日用电",
              type: "bar",
              stack: "Total",
              smooth: true,
              data: [120, 132, 101, 134, 90, 230, 210],
            },
            {
              name: "昨日用电",
              type: "line",
              stack: "Total",
              smooth: true,
              data: [220, 182, 191, 234, 290, 330, 310],
            },
          ],
        };
        this.$refs["line-chart-2"].$emit("setChart", option, true);
      });
    },
    getElectricityTrend() {
      this.$nextTick(() => {
        const option = {
          color: ["#0098FF", "#1BD870", "#FFCC33", "#FF6600"],

          xAxis: {
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },

          series: [
            {
              name: "生产用电",
              type: "line",
              stack: "Total",
              smooth: true,
              data: [120, 132, 101, 134, 90, 230, 210],
            },
            {
              name: "辅助生产用电",
              type: "line",
              stack: "Total",
              smooth: true,
              data: [220, 182, 191, 234, 290, 330, 310],
            },
            {
              name: "照明用电",
              type: "line",
              stack: "Total",
              smooth: true,
              data: [120, 132, 101, 134, 90, 230, 210],
            },
            {
              name: "其他用电",
              type: "line",
              stack: "Total",
              smooth: true,
              data: [120, 132, 101, 134, 90, 230, 210],
            },
          ],
        };
        this.$refs["line-chart-3"].$emit("setChart", option, true);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.electric-board {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #021035;
  .electric-board-head {
    font-size: 18px;
    height: 80px;
    background-color: #0080ff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    > div {
      display: flex;
      align-items: center;
      > span {
        font-size: 24px;
        font-weight: 500;
      }
    }
    .weather-box {
      margin-right: 10px;
      img {
        width: 20px;
        position: relative;
        top: 3px;
      }
      label {
        padding-left: 15px;
      }
    }
  }
}
.electric-board-container {
  width: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
  .left-box {
    width: 372px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }
  .right-box {
    flex: 1;
    margin-left: 12px;
    .right-session-1 {
      display: flex;
      .left-item {
        width: 449px;
        height: 500px;
        .pie-date {
          position: absolute;
          width: 100%;
          top: 20px;
          font-weight: bold;
          font-size: 16px;
        }
      }
      .content-box {
        display: flex;
        align-items: center;
        height: 100%;
      }
      .right-item {
        margin-left: 12px;
        flex: 1;
        .right-item-2 {
          margin-top: 12px;
        }
      }
    }
    .right-session-2 {
      margin-top: 12px;
    }
  }
  .right-info-box {
    width: 150px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    div {
      &:not(:first-child) {
        margin-top: 4px;
      }
    }
    .right-info {
      width: 100%;
      height: 91px;
      box-sizing: border-box;
      background-color: #0a224e;
      display: flex;
      flex-flow: column;
      align-items: center;
      &:first-child {
        .info-value {
          color: #ffcc33;
        }
      }
      &:last-child {
        .info-value {
          color: #0080ff;
        }
      }
      p {
        box-sizing: border-box;
        padding: 0 7px;
      }
      .info-title {
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        text-align: left;
        background-color: #102a5d;
        width: 100%;
      }
      .info-value {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
      }
      .info-time {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 24px;
        line-height: 24px;
        border-top: 1px solid #22427b;
        span {
          &:first-child {
            color: #ffffff40;
          }
          &:last-child {
            color: #0080ff;
          }
        }
      }
    }
  }
}
</style>
